import { render, staticRenderFns } from "./AcceptTask.vue?vue&type=template&id=2fd39a2e&scoped=true&"
import script from "./AcceptTask.vue?vue&type=script&lang=js&"
export * from "./AcceptTask.vue?vue&type=script&lang=js&"
import style0 from "./AcceptTask.vue?vue&type=style&index=0&id=2fd39a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd39a2e",
  null
  
)

export default component.exports